import type { FaireProductEntity } from "../../entity_types/product";

export const p_v2qz9x62gm: FaireProductEntity = {
  token: "p_v2qz9x62gm",
  type: "product",
  name: "Spirit Quartz Points, Cactus Quartz Clusters, You Choose Size",
  brandToken: "b_fak8czuqg9",
  brandName: "Mandala Gems",
  imageUrl:
    "https://cdn.faire.com/fastly/69edae0a692926ce4755e2a2a57a0dfdb0aa14bb049b3ca01574a8b4481ada10.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d5b537f47e65effd19c7fcc884caee6521e0808c42c16ef8b9f09d81c2b56c0.jpeg",
    "https://cdn.faire.com/fastly/2c0acc464f06c5c14a522d1ccc36757d9a2279b79ac80758a06e39433e8350f3.jpeg",
    "https://cdn.faire.com/fastly/9262e0884b8e903f1572207f6a7013ed9adf910362a1ca096d821b3b73a59df9.jpeg",
    "https://cdn.faire.com/fastly/7c5a9e59fac052d3122e9e7d72f1c6382ecfaff5185b7a6112ffc9a53272f6bc.jpeg",
    "https://cdn.faire.com/fastly/3c43cf6098cddbff249f6e11ca2b39b4d0db697045efa6b10ffc3d75b1822954.jpeg",
    "https://cdn.faire.com/fastly/3014f2aa31e6e3f4bcb34816f32ada0c60f5a27eabca86251b4fbba28f51232a.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "In the heart of Montecasino, South Africa, where the sun kisses the earth with a gentle warmth, there lies a treasure of enchantment: white spirit quartz. Picture a tiny magician's wand, delicately crafted by nature herself, sparkling with the secrets of the universe.\n\nIn its smaller form, it emerges as delicate points, each one a tiny beacon of light, as if the stars themselves decided to dance upon the earth. These miniature marvels hold within them the essence of purity, like flecks of snowflakes captured in crystalline splendor.\n\nBut it is in the grandeur of its clusters where white spirit quartz truly reveals its magic. Imagine a gathering of fairies, each one adorned with a crown of shimmering crystals, their laughter echoing through the enchanted forest. These clusters stand as majestic guardians, imbued with a serene energy that whispers tales of ancient wisdom and celestial mysteries.\n\nTo hold a piece of Montecasino's finest white spirit quartz is to hold a piece of pure wonderment. It is as if the very essence of tranquility and grace has been crystallized into a tangible form, inviting you to embark on a journey of imagination and discovery. So let yourself be swept away by the allure of these ethereal treasures, for in their presence, even the mundane becomes magical.\n",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:25.257Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
